import './stockFund.css';
import React from 'react';
import { STOCKS } from '../../../utils/stockFundamentals';
import { getTrendIndicator } from '../../../utils/portfolioMetrics';

const hasValue = (value) => value !== null && value !== undefined && value !== '';

const ratingLabel = (rating, t) => {
  if (rating === 'buy') return t('home.stockFundRatingBuy');
  if (rating === 'hold') return t('home.stockFundRatingHold');
  return t('home.stockFundRatingWatch');
};

const fmtB = (value) => {
  if (!hasValue(value)) return '';
  return `$${Number(value).toFixed(1)}B`;
};

const fmtMarketCap = (value) => {
  if (!hasValue(value)) return '';
  if (value >= 1e12) return `$${(value / 1e12).toFixed(2)}T`;
  if (value >= 1e9) return `$${(value / 1e9).toFixed(0)}B`;
  return `$${(value / 1e6).toFixed(0)}M`;
};

const trendArrow = (arrow) => {
  if (arrow === 'up') return '↑';
  if (arrow === 'down') return '↓';
  return '→';
};

const StockFundamentalsPanel = ({ stockFunds, stockFundsLoading, navigate, lang, t }) => {
  const cards = STOCKS
    .map((stock) => ({ stock, data: stockFunds?.[stock.ticker] }))
    .filter(({ data }) => data)
    .slice(0, 8);

  return (
    <div className="hp-pro-card hp-stock-fund-panel">
      <div className="hp-stock-fund-head">
        <div>
          <div className="hp-pro-card-title">{t('home.stockFundTitle')}</div>
          <div className="hp-stock-fund-sub">{t('home.stockFundSubtitle')}</div>
        </div>
      </div>
      {stockFundsLoading ? (
        <div className="hp-stock-fund-loading">{t('home.stockFundLoading')}</div>
      ) : !stockFunds || cards.length === 0 ? (
        <div className="hp-stock-fund-loading">{t('home.stockFundError')}</div>
      ) : (
        <div className="hp-stock-fund-grid">
          {cards.map(({ stock, data }) => {
            const revenueTrend = getTrendIndicator(data.revenueGrowth);
            return (
              <div
                key={stock.ticker}
                className="hp-stock-fund-card"
                onClick={() => navigate(`/stock/${stock.ticker}`)}
              >
                <div className="hp-stock-fund-card-head">
                  <img src={stock.logo} alt="" className="hp-stock-fund-logo" />
                  <div className="hp-stock-fund-card-title">
                    <strong>{lang === 'zh' ? stock.nameCn : stock.name}</strong>
                    <span>{stock.ticker}</span>
                  </div>
                  <em className={`hp-stock-fund-rating hp-stock-fund-rating-${data.rating || 'watch'}`}>
                    {ratingLabel(data.rating, t)}
                  </em>
                </div>
                <div className="hp-stock-fund-card-metrics">
                  {hasValue(data.revenue) && <span>{t('home.stockFundRevenue')} {fmtB(data.revenue)}</span>}
                  {hasValue(data.netIncome) && (
                    <span className={data.netIncome < 0 ? 'negative' : 'positive'}>
                      {t('home.stockFundNetIncome')} {data.netIncome >= 0 ? '+' : ''}{fmtB(data.netIncome)}
                    </span>
                  )}
                  {hasValue(data.marketCap) && <span>{lang === 'zh' ? '市值' : 'Mkt Cap'} {fmtMarketCap(data.marketCap)}</span>}
                  {revenueTrend.value && (
                    <span className={revenueTrend.className}>
                      {t('fundPage.growth')} {revenueTrend.value} {trendArrow(revenueTrend.arrow)}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className="hp-stock-fund-source">{t('home.stockFundSource')}</div>
    </div>
  );
};

export default StockFundamentalsPanel;
